import { useApolloClient } from '@apollo/client'
import { getOrganizationIdFromPath } from '@salescore/client-common'
import type { ViewQueryList } from '@salescore/core'
import { App } from 'antd'

import type { RSheetColumn, RSheetRecordNode } from '../../domain/column.ts'
import type { CopyMatrix } from '../../domain/copyMatrix'
import type { RSheetsCursor } from '../../domain/cursor/cursorTypes'
import { generateChangesFromCopy } from '../../domain/generateChangesFromCopy/generateChangesFromCopy'
import { useUpsertViewRecordsEntry } from '../../hooks/useUpsertViewRecordsEntry'
import { useRecordsImpl } from '../../recoil/records'
import type { SalescoreObjectAbility, ViewAbility } from '../../recoil/view/atoms'

export const usePasteCopyMatrix = (
  columns: Array<RSheetColumn<RSheetRecordNode>>,
  ability: ViewAbility & SalescoreObjectAbility,
  query: ViewQueryList | undefined,
) => {
  const records = useRecordsImpl()
  const { message } = App.useApp()
  const client = useApolloClient()
  const organizationId = getOrganizationIdFromPath()
  const upsertViewRecordsEntry = useUpsertViewRecordsEntry(query, ability)

  return async (copyMatrix: CopyMatrix, cursor: RSheetsCursor): Promise<void> => {
    const {
      newRecordChanges,
      recordChanges,
      magnifyingGlassChanges,
      relationChanges,
      recordsAfterHeightAdjustment,
      errors,
    } = await generateChangesFromCopy({
      copyMatrix,
      records,
      columns,
      cursor,
      query,
      organizationId,
      client,
    })
    if (errors.length > 0) {
      // eslint-disable-next-line sonarjs/todo-tag
      // TODO: feedbackMessagesAtomの名残でエラー時のフィードバックの責務が混入していて良くない
      errors.forEach((error) => {
        void message.warning(error.message)
      })
    }
    if (
      newRecordChanges.length > 0 ||
      recordChanges.length > 0 ||
      magnifyingGlassChanges.length > 0 ||
      relationChanges.length > 0
    ) {
      upsertViewRecordsEntry({
        newRecordChanges,
        recordChanges,
        magnifyingGlassChanges,
        relationChanges,
        recordsAfterHeightAdjustment,
      })
    }
  }
}
